import React, { useEffect, useState } from 'react';
import { Button } from 'appkit-react';
import { Skeleton } from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { API } from '@service';
import { quesModel } from '@model/questionmaires';

const ReviewResponses = ({ QSaccessData, questionnaireAccessHandler }) => {
  const history = useHistory();
  const projectId = useSelector((state) => state.common.currentId);
  const [pageData, setPageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
  const [anchor, setnAnchor] = useState('');

  useEffect(() => {
    const acr = history.location.hash.split('#')[1]?.toLowerCase();
    if (acr) {
      setnAnchor(acr);
    }
  }, []);

  useEffect(() => {
    (async () => {
      const accessRes = await API.getQuestionnaireAccess(projectId);
      questionnaireAccessHandler(accessRes);

      const result = await API.getReviewResponses(projectId);
      const arr = [];
      Array.isArray(result) &&
        result.forEach((item) => {
          const sectionName = item.name.toLowerCase();
          if (!accessRes[sectionName]?.disabled) {
            arr.push(item);
          }
        });
      setPageData(arr);
      setIsLoading(false);
    })();
  }, [projectId]);

  const reviewResponseDataHandler = () => {
    const arr = [];
    Array.isArray(pageData) &&
      pageData.forEach((item) => {
        const sectionName = item.name.toLowerCase();
        if (!QSaccessData[sectionName]?.disabled) {
          arr.push(item);
        }
      });
    setPageData(arr);
  };
  useEffect(() => {
    reviewResponseDataHandler();
  }, [JSON.stringify(QSaccessData)]);

  useEffect(() => {
    if (anchor && !isLoading && pageData && document.getElementById(anchor)) {
      document.getElementById(anchor).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }, [anchor, isLoading, pageData]);

  const sequenceFilter = (sectionNumber, sequenceNumber) => {
    const questionSequence = [0, 7, 3, 3];
    let num = sequenceNumber;
    for (let i = 0; i < sectionNumber; i++) {
      num -= questionSequence[i];
    }
    return num - 1;
  };

  const getAnswer = (sectionName, questionId, answer = {}) => {
    if (answer.choice) {
      if (quesModel[sectionName][questionId]?.options.length !== undefined) {
        return quesModel[sectionName][questionId]?.options[answer.choice - 1]
          .text;
      }
      if (quesModel[sectionName][questionId]?.options.extremeTexts) {
        return quesModel[sectionName][questionId]?.options.extremeTexts[
          answer.choice - 1
        ];
      }
    }
    if (answer.choices) {
      const result = answer.choices.map(
        (choice) =>
          quesModel[sectionName][questionId]?.options[choice - 1]?.text ||
          quesModel[sectionName][questionId]?.options.extremeTexts[choice - 1],
      );
      return result.map((res) => (
        <>
          {res}
          <br />
        </>
      ));
    }
    if (answer.choiceCollection) {
      // console.log(sectionName, questionId, answer);

      return quesModel[sectionName][questionId]?.options.map((res, i) => (
        // console.log(res, i, answer.choiceCollection[i]);
        <>
          <div className="answer-title">{res.section}</div>
          {res.options[answer.choiceCollection[i] - 1].text}
        </>
      ));
    }

    if (sectionName === 'execution') {
      if (answer.choice) {
        return (
          <>
            {
              quesModel[sectionName][questionId]?.options.radioText[
                answer.choice - 1
              ].text
            }
            {/* {answer.text ? (
              <>
                <br />
                {answer.text}
              </>
            ) : null} */}
          </>
        );
      }
      if (answer.buyer && answer.target) {
        return (
          <div className="execution-section-wrap">
            {Object.values(answer).map((a, i, all) => (
              <div className="execution-sp-section" key={`exe-${i}`}>
                <div className="answer-title client-title">
                  {i === 0 ? 'Buyer' : 'Target'}
                </div>
                {a.noApplication ? (
                  <div className="pre-section">
                    <div className="answer-title">No Application</div>
                  </div>
                ) : (
                  <div className="execution-section">
                    <div className="per-section">
                      {a.application ? (
                        <>
                          {a.vendor ? (
                            <div className="answer-title">
                              Vendor & Application
                            </div>
                          ) : (
                            <div className="answer-title">Application</div>
                          )}

                          {a.vendor
                            ? `${a.vendor} - ${a.application}`
                            : a.other
                            ? `Other - ${a.other}`
                            : a.application}
                        </>
                      ) : (
                        <>
                          <div className="answer-title">Vendor & Version</div>
                          {`${a.vendor} - ${a.version || a.other}`}
                        </>
                      )}
                    </div>
                    <div className="per-section">
                      <div className="answer-title">Data hosted on</div>
                      {
                        quesModel[sectionName][questionId]?.options.radioText[
                          a.radio - 1
                        ]?.text
                      }
                    </div>
                    <div className="per-section">
                      <div className="answer-title">
                        {a.checker.map((res, k) => (
                          <div key={`checker-${k}`}>
                            {
                              quesModel[sectionName][questionId]?.options
                                .checkerText[res - 1]?.text
                            }
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        );
      }
    }
    // if (quesModel[sectionName][questionId].options.count) {
    //   return quesModel[sectionName][questionId].options.extremeTexts[answerId];
    // }
    // return quesModel[sectionName][questionId].options[answerId].text;
  };

  return (
    <div className="review-page">
      <Skeleton loading={isLoading} active paragraph={{ rows: 7 }}>
        <div className="title">Diagnostic Responses</div>
        <div className="sub-title">
          Thank you for completing the questionnaire.
          <br />
          Please review your responses and submit.
        </div>
        {pageData &&
          pageData.map((res, i, all) => (
            <section key={res.name}>
              <div className="section-title">
                <span>{res.name}</span>
              </div>
              <div className="section-content">
                {res.data.map((question, j) => (
                  <div className="section-row" key={`row-key-${j}`}>
                    <div className="question">
                      <span
                        className="appkiticon icon-pencil-fill"
                        onClick={() => {
                          if (
                            sequenceFilter(
                              question.sectionNumber,
                              question.sequenceNumber,
                            ) === 0
                          ) {
                            history.push(
                              `/questionnaires/${res.name.toLowerCase()}`,
                            );
                            return;
                          }
                          history.push(
                            `/questionnaires/${res.name.toLowerCase()}/${sequenceFilter(
                              question.sectionNumber,
                              question.sequenceNumber,
                            )}`,
                          );
                        }}
                      />
                      {question.shortDescription}
                    </div>
                    <div className="answer">
                      {getAnswer(
                        res.name.toLowerCase(),
                        sequenceFilter(
                          question.sectionNumber,
                          question.sequenceNumber,
                        ),
                        question.answer,
                      )}
                    </div>
                  </div>
                ))}
              </div>
              <div id={all[i + 1]?.name.toLowerCase()} />
            </section>
          ))}
        <Button
          size="xl"
          className="submit-review-button"
          isLoading={submitButtonLoading}
          onClick={async () => {
            setSubmitButtonLoading(true);
            const res = await API.submitReviewResponses(projectId);
            if (res.message.includes('successfully')) {
              history.push('/questionnaires/complexity');
            }
          }}
        >
          Go To Report
        </Button>
      </Skeleton>
    </div>
  );
};

export default ReviewResponses;
